import { ComponentPropsContext } from '@sitecore-jss/sitecore-jss-nextjs';
import { Auth } from 'components/helpers/Auth';
import PageLayout from 'components/layout/PageLayout';
import { SitecorePageProps } from 'lib/sitecore/page-props';
import { sitecorePagePropsFactory } from 'lib/sitecore/page-props-factory';
import { DictionaryContext } from 'lib/sitecore/use-dictionary';
import { GetStaticProps, NextPage } from 'next';
import { componentFactory } from 'temp/component-factory';
import { CartContextProvider } from 'components/globalContext/CartContext';
import { FastSitecoreContext } from 'lib/sitecore/fast-sitecore-context';
import { useRouter } from 'next/router';
import {
  useGtmDatalayerLoadPush,
  referrerUrlSetter,
  ErrorPageDataLayerObject,
} from 'lib/util/gtm-datalayer';

export const getStaticProps: GetStaticProps = async (context) => {
  const props = await sitecorePagePropsFactory.create({
    ...context,
    params: { ...context.params, path: '/_404' },
  });

  return {
    props,
    revalidate: 5,
    notFound: false,
  };
};

const SitecorePage: NextPage<
  Pick<SitecorePageProps, 'componentProps' | 'layoutData' | 'dictionary'>
> = ({ componentProps, layoutData, dictionary }) => {
  const router = useRouter();
  useGtmDatalayerLoadPush({
    event: 'e_httpError',
    httpErrorCode: 404,
    sourceUrl: router.asPath,
    referrerUrl: referrerUrlSetter(),
  } as ErrorPageDataLayerObject);

  return (
    <ComponentPropsContext value={componentProps}>
      <FastSitecoreContext layoutData={layoutData} componentFactory={componentFactory}>
        <DictionaryContext.Provider value={dictionary}>
          <Auth skipAuthCheck>
            <CartContextProvider>
              <PageLayout isSearchRobot={false} />
            </CartContextProvider>
          </Auth>
        </DictionaryContext.Provider>
      </FastSitecoreContext>
    </ComponentPropsContext>
  );
};

export default SitecorePage;
